import * as React from 'react';

function SvgSpeechBubble(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 15" {...props}>
      <path
        fill="#007BFF"
        d="m.103 14.47 2.94-2.607A7.34 7.34 0 0 1 1.604 7.5C1.607 3.358 5.052 0 9.302 0S17 3.358 17 7.501c0 4.138-3.437 7.491-7.681 7.499H.315c-.287 0-.424-.344-.212-.532z"
      />
    </svg>
  );
}
export default SvgSpeechBubble;
